"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientError = void 0;
var tslib_1 = require("tslib");
var ClientError = (function (_super) {
    tslib_1.__extends(ClientError, _super);
    function ClientError(m, payload) {
        var _this = _super.call(this, m) || this;
        _this.payload = payload;
        return _this;
    }
    ClientError.prototype.toString = function () {
        return 'Givz Core Client Error' + this.message;
    };
    return ClientError;
}(Error));
exports.ClientError = ClientError;
//# sourceMappingURL=errors.js.map